import React, {useEffect, useState} from "react";
import {getDisplayedSubscriptionsCount} from "../../api/organization-unit-functions";
import {useTranslation} from "react-i18next";
import {useOrganization} from "../organizations/organization-context";
import Button from "@material-ui/core/Button";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import {Link, useMediaQuery} from "@material-ui/core";
import {SubscriptionsCountPieChart} from "./SubscriptionsCountPieChart";
import {Link as RouterLink} from 'react-router-dom';
import Typography from "@material-ui/core/Typography";
import {run} from "../../utils/function-util";
import {Close, ExpandLess, ExpandMore} from "@material-ui/icons";
import clsx from "clsx";
import IconButton from "@material-ui/core/IconButton";
import {useApiNotification} from "../ui/ApiNotificationProvider";
import useWindowDimensions from "../_shared/useWindowDimensions";
import {SubscriptionType} from "../../models/subscription-model";
import {Roles} from "../../auth/roles";
import {useCapability} from "../../auth/CapabilityContext";


const useStyles = makeStyles(theme => ({
        orgUnitSubscriptionCount: {
            'display': 'flex',
            'justify-content': 'space-around',
            'flex-wrap': 'wrap',
        },
        distributeSubContainer: {
            'display': 'flex',
            'justify-content': 'flex-end',
            'marginTop': theme.spacing(2),
            '& > *': {
                'margin-left': '10px'
            }
        },
        distributeSubContainerOnMobile: {
            'display': 'flex',
            'justify-content': 'space-around',
            'marginTop': theme.spacing(2)
        },
        header: {
            'display': 'flex',
            'justify-content': 'space-between',
            'align-items': 'start'
        },
        orgUnitNameContainer: {
            overflow: 'hidden',
            display: '-webkit-box',
            'line-clamp': '3',
            '-webkit-box-orient': 'vertical'
        },
        subscriptionOverview: {
            'padding': theme.spacing(2)
        }
    })
);

export const OrganizationUnitSubscriptionsOverview = (props: any) => {
    const classes = useStyles();
    const {hasRole} = useCapability();

    const {organizationUnit, onCloseOverview} = props;
    const [currentOrganization] = useOrganization();

    const [subscriptionsCounts, setSubscriptionsCounts] = useState([]);
    const {t} = useTranslation();
    const {handleError} = useApiNotification();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const {height} = useWindowDimensions();
    const [openCollapsable, setOpenCollapsable] = useState((height > 720));

    const handleClickCollapsable = () => {
        setOpenCollapsable(!openCollapsable);
    };

    useEffect(
        run(
            async () => {
                if (!!currentOrganization && !!organizationUnit) {
                    const result = await getDisplayedSubscriptionsCount(currentOrganization.id, organizationUnit.id, true)
                    return result.filter(i => !(i.type === SubscriptionType.Embedded && i.total === 0));// hide machines stats when no subscription available
                }
                return [];
            },
            setSubscriptionsCounts,
            handleError
        ),
        [organizationUnit]
    );

    useEffect(() => {
        setOpenCollapsable(height > 720)
    }, [height]);

    return (
        <div className={classes.subscriptionOverview}>
            {organizationUnit &&
            <React.Fragment>
                <div className={classes.header}>
                    <div className={classes.orgUnitNameContainer}>
                        <Typography gutterBottom variant="h4">{organizationUnit.name}</Typography>
                    </div>
                    {isMobile && <Close onClick={onCloseOverview}/>}
                    <IconButton onClick={handleClickCollapsable} color="inherit">
                        {openCollapsable ? <ExpandLess fontSize="large"/> : <ExpandMore fontSize="large"/>}
                    </IconButton>
                </div>
                <div className={classes.orgUnitSubscriptionCount}>
                    {
                        subscriptionsCounts.map((subscriptionsCount, index) => <SubscriptionsCountPieChart
                            subscriptionCount={subscriptionsCount}
                            openCollapsable={openCollapsable}
                            key={`SubscriptionCounts${index}`}></SubscriptionsCountPieChart>)
                    }
                </div>
                    <div
                        className={clsx(isMobile ? classes.distributeSubContainerOnMobile : classes.distributeSubContainer)}>
                        {hasRole(Roles.ADMIN) ?
                        <Link component={RouterLink}
                              to={`/organization-units/${organizationUnit.id}/account-numbers`}
                              style={{textDecoration: 'none'}}>
                            <Button variant="contained" disableElevation
                                    color="primary">{t("OrganizationUnits.Menu.AccountNumbers")}</Button>
                        </Link> : null}
                        <Link component={RouterLink}
                              to={`/organization-units/${organizationUnit.id}/edit`}
                              style={{textDecoration: 'none'}}>
                            <Button variant="contained" disableElevation
                                    color="primary">{t("OrganizationUnits.Menu.CreateOrgUnit")}</Button>
                        </Link>
                        {subscriptionsCounts.length > 0 ?
                            <Link component={RouterLink}
                                  to={`/organization-units/${organizationUnit.id}/subscriptions-distribution`}
                                  style={{textDecoration: 'none'}}>
                                <Button variant="contained" disableElevation
                                        color="primary">{t("Subscription.DistributeSubscriptions.Title")}</Button>
                            </Link>
                         : null
                        }
                    </div>
            </React.Fragment>
            }

        </div>
    )
};
